import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getLenisInstance } from "@/lib/lenisInstance";

const DELAYS = [100, 400, 800, 1400];

export const HashScroll: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace("#", "");

    const scrollToTarget = () => {
      const el = document.getElementById(id);
      if (!el) return;
      const lenis = getLenisInstance();
      if (lenis) {
        lenis.scrollTo(el, { offset: -90, immediate: true });
      } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };

    const timers = DELAYS.map((delay) => setTimeout(scrollToTarget, delay));
    return () => timers.forEach(clearTimeout);
  }, [location]);

  return null;
};
